import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StripePaymentRequestButtonComponentDef } from '@df/module-stripe/stripe-payment-request-button.component.def';
@Component({
    selector: 'stripe-payment-request-button',
    templateUrl: './stripe-payment-request-button.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StripePaymentRequestButtonComponent extends StripePaymentRequestButtonComponentDef implements OnInit {}
